import React from 'react';
import PropTypes from 'prop-types';
import slugify from 'slugify';
import InputCheckbox from './inputCheckbox';
import InputToggleButton from './inputToggleButton';

function getStyle(checked, valid) {
  if (valid) {
    if (checked) {
      return 'success';
    } else {
      return 'success';
    }
  } else {
    if (checked) {
      return 'error';
    } else {
      return;
    }
  }
}

const Answers = ({ question, validate, onAnswer }) => {
  switch (question.type) {
    case 'single':
      return question.answers.map(answer => {
        const checked = question.checked.some(a => a.text === answer.text);
        const style = validate ? getStyle(checked, answer.valid) : null;

        return (
          <InputCheckbox
            key={slugify(answer.text)}
            name={slugify(answer.text)}
            label={answer.text}
            style={style}
            checked={checked}
            onChange={onAnswer ? () => onAnswer(answer) : null}
          />
        );
      });
    case 'true-or-false':
      return question.answers.map(answer => {
        const checked = question.checked.some(a => a.text === answer.text);
        const style = validate ? getStyle(checked, answer.valid) : null;

        return (
          <InputToggleButton
            key={slugify(answer.text)}
            name={slugify(answer.text)}
            label={answer.text}
            style={style}
            checked={checked}
            onClick={onAnswer ? () => onAnswer(answer) : null}
          />
        );
      });
    default:
      return <></>;
      break;
  }
};

export default Answers;
